import * as compare from './comparators'
import rank from './rank'
import observeDom from './observe-dom'

import mapImageIdToImage from './mapImageIdToImage'
import mapOverlayData from './mapOverlayData'
import mapOverlayOptions from './mapOverlayOptions'
import mapTemplateData from './mapTemplateData'
import mapTemplateOptions from './mapTemplateOptions'
import mapWindowData from './mapWindowData'
import overlayDataProp from './overlayDataProp'
import overlayOptionProp from './overlayOptionProp'
import templateDataProp from './templateDataProp'
import templateOptionProp from './templateOptionProp'
import windowDataProp from './windowDataProp'
import windowTitleProp from './windowTitleProp'

const mapRecord = function (record, patterns) {
  if (typeof record !== 'object') return record
  const result = {}
  for (let k in patterns) {
    if (!patterns.hasOwnProperty(k)) continue
    result[k] = patterns[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
      return record[p1] || ''
    })
  }
  return result
}

export {
  compare,
  rank,
  observeDom,

  mapRecord,

  mapImageIdToImage,
  mapOverlayData,
  mapOverlayOptions,
  mapTemplateData,
  mapTemplateOptions,
  mapWindowData,
  overlayDataProp,
  overlayOptionProp,
  templateDataProp,
  templateOptionProp,
  windowDataProp,
  windowTitleProp
}



// WEBPACK FOOTER //
// ./src/utils/index.js